import { useCallback, useRef } from 'react';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Calling `track` before `initialize` results in events being lost.
 * This uses two refs to queue events and flush them after `initialize` resolves.
 */
export const useMixpanelQueue = () => {
  const isMixpanelReadyRef = useRef(false);
  const mixpanelEventQueueRef = useRef<ReadonlyArray<() => void>>([]);

  const queueMixpanelCall = useCallback((send: () => void) => {
    if (isMixpanelReadyRef.current) {
      send();
      return;
    }

    mixpanelEventQueueRef.current = [...mixpanelEventQueueRef.current, send];
  }, []);

  const onMixpanelReady = useCallback(() => {
    isMixpanelReadyRef.current = true;

    const queuedEvents = mixpanelEventQueueRef.current;

    mixpanelEventQueueRef.current = [];
    queuedEvents.forEach((send) => send());
  }, []);

  return { queueMixpanelCall, onMixpanelReady };
};
